import TrackingService from './trackingService';

export default TrackingService;
